const config = {
  domain: process.env.REACT_APP_DOMAIN,
  clientId: process.env.REACT_APP_CLIENT_ID,
  audience: process.env.REACT_APP_BASE_URL,
};

export default config;
